const INIT_STATE = {
   settings: [],
};
export default (state = INIT_STATE, action) => {
   switch (action.type) {
      case "SET_WIDGET_SETTINGS": {
         return {
            ...state,
            settings: action.payload,
         };
      }
      case "UPDATE_WIDGET_SETTINGS": {
         const obj = {};

         for (const property in action.payload) {
            obj[property] = action.payload[property];
         }

         return {
            ...state,
            settings: obj,
         };
      }
      default:
         return state;
   }
};
